import { AutomationsPresentationV1 } from 'Automations/automationEditor/types'

export const createEmptyAutomationPresentation =
  (): AutomationsPresentationV1 => {
    return {
      version: 1,
      nodes: [
        {
          id: crypto.randomUUID(),
          type: 'START_PLACEHOLDER',
          position: { x: 0, y: 0 },
          data: { name: '' },
          // @ts-expect-error
          selected: true
        }
      ],
      edges: []
    }
  }
